module.exports = __webpack_public_path__ + "static/media/kouzoumis_landing_image_4.64426c7b.jpg";